// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b884b157","389":"b8d9788e","732":"18c0ea78","857":"bf3d539b","977":"4d8db55d"}[chunkId] + ".chunk.js";
};